<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	const { class: customClass, messages }: { class?: ClassValue; messages: string[] } = $props();

	function invalid(input: HTMLInputElement, message: string): void {
		input.setCustomValidity(message);
		input.reportValidity();
	}
</script>

{#if messages.length > 0}
	<div class={["flex flex-col gap-2 text-primary", customClass]}>
		{#each messages as message (message)}
			<p class="relative">
				{message}
				<input type="text" class="absolute opacity-0 inset-0" use:invalid={message} />
			</p>
		{/each}
	</div>
{/if}
